import { FormBuilder } from '@angular/forms';
import type { FormGroup } from '@angular/forms';
import { inject, Injectable } from '@angular/core';
import { FIELD_REQUIRED, FormValidator } from '@shared/reactive-forms/form-fields-validate.helper';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordBuildFormService {
  private readonly formBuilder = inject(FormBuilder);

  /**
   * Construye y retorna un formulario de recuperación de contraseña.
   */
  public buildForgotPasswordForm(): FormGroup {
    return this.formBuilder.group({
      email: FormValidator.requiredEmailMinLength(FIELD_REQUIRED),
    });
  }
}
